import ".././styles/styles.css";
import ".././styles/AdvertiseBanner.css";
import React, { useState, useEffect, useLayoutEffect } from "react";

// --- Configuration for Google Sheets API ---
const GOOGLE_API_KEY = 'AIzaSyCLfnoX4kMuKDpNMQ9HZ2qJP28aRKNd2Hg'; 
const SPREADSHEET_ID = '16I9JOyUgHldKvU8AqhPl8ABxFRwBfb_mk37zbMhU1mU'; 
const SHEET_RANGE = 'ads!A:D';

function AdvertiseBanner() {
    const [index, setIndex] = useState(0);
    const [ads, setAds] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAds = async () => {
            setLoading(true);
            setError(null);
            try {
                // Construct the Google Sheets API URL
                const googleSheetsApiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${SHEET_RANGE}?key=${GOOGLE_API_KEY}`;

                const response = await fetch(googleSheetsApiUrl);

                if (!response.ok) {
                    const errorJson = await response.json(); // Google API returns error as JSON
                    const errorMessage = errorJson.error ? errorJson.error.message : response.statusText;
                    throw new Error(`HTTP Error! Status: ${response.status} - ${errorMessage}`);
                }

                const jsonData = await response.json();

                if (jsonData && jsonData.values) {
                    // The first row of the sheet is the headers
                    const headers = jsonData.values[0];
                    const rows = jsonData.values.slice(1);

                    const parsedAds = rows.map(row => {
                        let ad = {};
                        headers.forEach((header, colIndex) => {
                            ad[header.toLowerCase()] = row[colIndex];
                        });
                        return ad;
                    });
                    setAds(parsedAds);
                } else {
                    console.warn("Google Sheets API ads data not found or response is empty.", jsonData);
                    setAds([]);
                }
            } catch (err) {
                console.error("Error fetching ads data:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAds();
    }, []); // Run once on mount

    // Slideshow logic
    useEffect(() => {
        const lastIndex = ads.length - 1;
        if (index < 0) {
            setIndex(lastIndex);
        }
        if (index > lastIndex) {
            setIndex(0);
        }
    }, [index, ads]);

    useEffect(() => {
        let slider;
        // Only start the slider if ads data is loaded and available
        if (ads.length > 0) {
            slider = setInterval(() => {
                setIndex((prevIndex) => prevIndex + 1);
            }, 7000);
        }
        return () => {
            if (slider) {
                clearInterval(slider);
            }
        };
    }, [index, ads]); // Add ads to dependency array to restart timer if data changes
    
    // Render loading, error, or no ads message
    if (loading) {
        return <section id="promo-banner" style={{ minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><p>Loading promotions...</p></section>;
    }

    if (error) {
        return <section id="promo-banner" style={{ minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><p>Error loading promotions: {error.message}</p></section>;
    }

    return (
        <section id="promo-banner">
            {ads.map((ad, adIndex) => {
                const { id, image, title, description, link } = ad;
                let position = "nextSlide";
                if (adIndex === index) {
                    position = "activeSlide";
                }
                if (
                    adIndex === index - 1 ||
                    (index === 0 && adIndex === ads.length - 1)
                ) {
                    position = "lastSlide";
                }

                return (
                    <article key={id} className={position}>
                        <div id="promo-details">
                            <div id="promo-text">
                                <h2>{title}</h2>
                                <h3>{description}</h3>
                            </div>
                        </div>
                        <div id="promo-img-container">
                            <a href={link} target="_blank" rel="noopener noreferrer">
                                <img id="promo-pic" src={image} alt={title} />
                            </a>
                        </div>
                    </article>
                );
            })}
        </section>
    );
}

export default AdvertiseBanner;